import type { MapId } from "../shared/maps";
import { normalizeName } from "../shared/score";
import { createAirScreen, type Screen } from "./air/screen";
import { createGroundScreen } from "./ground/screen";
import { $, getCallsign, initEndDialog, refreshLeaderboards, setCallsign } from "./ui";

type ScreenId = "login" | "maps" | MapId;

const screens: Record<MapId, Screen> = { air: createAirScreen(), ground: createGroundScreen() };
initEndDialog();

function show(id: ScreenId): void {
  for (const s of ["login", "maps", "air", "ground"] as ScreenId[]) $(`#${s}`).hidden = s !== id;
  for (const el of document.querySelectorAll(".callsign")) el.textContent = getCallsign() ?? "";
  if (id === "login") {
    const input = $<HTMLInputElement>("#callsign");
    input.value = getCallsign() ?? "";
    input.focus();
  }
  if (id === "air" || id === "ground") screens[id].show();
  void refreshLeaderboards();
}

$<HTMLFormElement>("#login-form").addEventListener("submit", (e) => {
  e.preventDefault();
  const name = normalizeName($<HTMLInputElement>("#callsign").value);
  if (!name) {
    $("#login-error").textContent = "Use 2–16 letters, digits, spaces, - or _.";
    return;
  }
  $("#login-error").textContent = "";
  setCallsign(name);
  show("maps");
});

for (const el of document.querySelectorAll<HTMLElement>("[data-goto]")) {
  el.addEventListener("click", () => show(el.dataset.goto as ScreenId));
}

show(getCallsign() ? "maps" : "login");
